// extracted by mini-css-extract-plugin
export default {"dismiss":"DismissButton_dismiss__qXF4F"};